import { render, staticRenderFns } from "./MarriedSingle.vue?vue&type=template&id=065bf903&"
import script from "./MarriedSingle.vue?vue&type=script&lang=js&"
export * from "./MarriedSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports